import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AlarmIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8.75 5a.75.75 0 0 0-1.5 0v3c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H8.75z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
			clipRule="evenodd"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M3.63.504a.75.75 0 0 1-.177 1.046 8 8 0 0 0-1.845 1.83.75.75 0 1 1-1.216-.877A9.5 9.5 0 0 1 2.585.326a.75.75 0 0 1 1.046.178Zm8.737 0a.75.75 0 0 0 .177 1.046 8 8 0 0 1 1.845 1.83.75.75 0 0 0 1.216-.877A9.5 9.5 0 0 0 13.412.326a.75.75 0 0 0-1.046.178Z"
			clipRule="evenodd"
		></path>
	</svg>
))
